import React from "react";
import { Result } from "antd";
import { ResultStatusType } from "antd/lib/result";
import { BackToHomeButton } from "../../shared/buttons/BackToHomeButton";

export const COREError: React.FC<{
  title?: string;
  extra?: string;
  status?: ResultStatusType;
  path?: string;
  onClick?: () => void;
}> = ({
  title = "An unknown error occurred. Refreshing the page might help.",
  extra = "The most likely cause is a required site update. Refreshing the page will resolve this.",
  status = "warning",
  path = "/",
  onClick,
  ...otherProps
}) => {
  return (
    <Result
      status={status}
      title={title}
      extra={[
        <div key={"bnt-home-block"} className="bnt-home-block">
          <BackToHomeButton path={path} onClick={onClick} />
        </div>,
      ]}
      className="core-result-error"
      {...otherProps}
    />
  );
};
